module.exports = __webpack_public_path__ + "img/Invasion-MELA_GSE185386.ba23bdbc.png";